<div #wrapper class="relative" [attr.data-testid]="'field-' + (businessProperty || property)">
  <div class="mt-6" [ngClass]="{
    'flex items-center gap-2': isCheckbox && effIsEditMode,
    'space-y-1': !(isCheckbox && effIsEditMode)
  }">

    <!-- Label AVANT l'input (par défaut) -->
    @if (!(isCheckbox && effIsEditMode) && labelPosition !== 'below') {
    <label class="{{effSkin?.upperCaseSmallLabel || 'text-xs font-medium text-gray-500 uppercase tracking-wide'}}">
      {{ effLabel | translate }}
    </label>
    }

    <!-- Contenu (input) -->
    @if (!effIsEditMode) {
    <div class="p-1 border border-gray-300 rounded-sm bg-gray-50 text-sm">
      {{ getDisplayValue() }}
      @if (fuseauDuChamp; as iana) {
      <app-timezone-icon class="ml-1" [iana]="iana"></app-timezone-icon>
      }
    </div>
    } @else {
    <ng-content></ng-content>
    }

    <!-- Label APRÈS l'input (quand labelPosition === 'below') -->
    @if (!(isCheckbox && effIsEditMode) && labelPosition === 'below') {
    <label class="{{effSkin?.upperCaseSmallLabel || 'text-xs font-medium text-gray-500 uppercase tracking-wide'}}">
      {{ effLabel | translate }}
    </label>
    }

    <!-- Label pour checkboxes en edit mode -->
    @if (isCheckbox && effIsEditMode) {
    <label for="{{uniqueId}}" class="text-xs font-medium text-gray-500 uppercase tracking-wide cursor-pointer">
      {{ effLabel | translate }}
    </label>
    }
  </div>

  @if (effPropretyHasChanged()) {
  <app-modified-field-badge [index]="effIndex"
    [totalModified]="effTotalModified"
    [property]="trackedProperty"
    [entity]="effEntity"
    [toggleUndoFn]="effToggleUndo"
    (undoRedoPerformed)="effTriggerFlash(trackedProperty)">
  </app-modified-field-badge>
  }

  @if (effHasValidationErrors()) {
  <div class="text-red-600 text-xs mt-1">
    @for (error of effGetValidationErrors(); track error) {
    <div>{{ error | translate }}</div>
    }
  </div>
  }
</div>
